import {createElement, PropTypes} from 'rlink-react';
import connectToPathForContent from 'rlink-repos/connectToPathForContent';

function ContentSource ({src, media, pathForContent}) {
  return <source media={media} srcSet={pathForContent(src)} />;
}

ContentSource.propTypes = {
  src: PropTypes.string.isRequired,
  media: PropTypes.string,
  pathForContent: PropTypes.func,
};

export default connectToPathForContent(ContentSource);



// WEBPACK FOOTER //
// ./lib/rlink-repos/components/ContentSource.jsx